import React from 'react';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  return <section className="py-20 bg-white" data-id="element-242">
      <div className="container mx-auto px-4" data-id="element-243">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-slate-900 mb-16" data-id="element-244">
          Historias Reales de Madres como Tú
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-245">
          {/* Testimonial 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-slate-50 p-8 rounded-2xl relative" data-id="element-246">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-slate-200" data-id="element-247" />
            <div className="flex text-brand-primary mb-4" data-id="element-248">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-249" />)}
            </div>
            <p className="text-slate-700 italic mb-6" data-id="element-250">
              "Mi hijo pasaba de 4 horas diarias a gritos cuando se la quitaba.
              Aplicamos el protocolo RECONQUISTA y en 3 días bajamos a 1 hora.
              Anoche cenamos todos juntos por primera vez en meses sin pantallas
              en la mesa."
            </p>
            <div className="flex items-center" data-id="element-251">
              <div className="w-10 h-10 bg-slate-200 rounded-full flex items-center justify-center font-bold text-slate-500 mr-3" data-id="element-252">
                MC
              </div>
              <div data-id="element-253">
                <p className="font-bold text-slate-900" data-id="element-254">María Camila</p>
                <p className="text-xs text-slate-500" data-id="element-255">Mamá de niño de 7 años</p>
              </div>
            </div>
          </motion.div>

          {/* Testimonial 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-slate-50 p-8 rounded-2xl relative" data-id="element-256">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-slate-200" data-id="element-257" />
            <div className="flex text-brand-primary mb-4" data-id="element-258">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-259" />)}
            </div>
            <p className="text-slate-700 italic mb-6" data-id="element-260">
              "Estaba desesperada. Pensé que mi hija me odiaría si le ponía
              límites. El libro me enseñó a poner normas con amor. La conexión
              pre-límite cambió todo. Ya no hay portazos."
            </p>

            <div className="flex items-center" data-id="element-261">
              <div className="w-10 h-10 bg-slate-20" data-id="element-262" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}